import React, { useState, useEffect, useRef } from "react";
import {
    Spinner
} from "reactstrap";

const TradeTotalGT = ({ ...props }) => {
    const [dataa, setdataa] = useState([])
    const [load, setload] = useState(true)
    const getdata = async () => {
        const sendData = {
            YearId: Number(props.year),
            ToYearId: Number(props.toyear),
            ToMonthId: Number(props.tomonth),
            MonthId: Number(props.Month)
        }
        ////console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/Reporttotaltradegt', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (setdataa.length > 0) {

                        setdataa(data[0])
                    } else {
                        setdataa([])
                    }
                    setload(false)
                })

    };
   

    useEffect(() => {
        setload(true)
        getdata()

    }, [props.parametersId, props.UserId, props.generate])
  
    return (
        <>
            {load ? <Spinner color="success" /> : 
              <>

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                        <label> {dataa.genderMale4 >=0 ?dataa.genderMale4 :0}</label>

                </td>
                
             
                    </>
           
        }</>
    );
};

export default TradeTotalGT;
